<form *ngIf="block && form" [formGroup]="form" class="flex flex-col gap-6 bg-pl-gray-100 pb-6">
  <ng-container [formArrayName]="FormControlName.blocks">
    <ng-container *ngFor="let block of formArrayBlocks.controls; let index = index">
      <ng-container [ngSwitch]="block.value.element">
        <pl-block-html *ngSwitchCase="BlockType.html" [formControlName]="index + ''" />
        <pl-block-textbox
          *ngSwitchCase="BlockType.textbox"
          [isDisabled]="isDisabled"
          [invalidatePatternValidationIfEmojiInValue]="true"
          [formControlName]="index + ''"
        />
      </ng-container>
    </ng-container>
  </ng-container>
</form>
